import React, { useEffect } from 'react';
import { useCopyMode } from '../components/copy/copyMode';
import { IntroSplash } from '../components/IntroSplash';
import { MarketingHero } from '../components/MarketingHero';
import { AICoworkers } from '../components/AICoworkers';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { QuickCapture } from '../components/QuickCapture';
import { NarrativeSection } from '../components/NarrativeSection';
import { ProductDemo } from '../components/ProductDemo';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
// The original Giga marketing homepage, preserved verbatim and now served at
// /future while we explore a new home screen at "/".
export function FutureHome() {
  const {
    setMode
  } = useCopyMode();
  // /future is the canonical "current" Giga homepage — always show the AI
  // colleague / AI Co-pilot for Teams copy, regardless of the global toggle.
  useEffect(() => {
    setMode('current');
  }, [setMode]);
  return <>
      <IntroSplash data-id="element-9377" data-mp="1zrlr64a4airm" />
      <MarketingHero data-id="element-9378" data-mp="1266ark52zlvi" />
      <AICoworkers data-id="element-9379" data-mp="126piy94xivwc" />
      {/* Unified dark "How it works + Connections" section. */}
      <HowItWorksConnections data-id="element-9380" data-mp="174hk7trgrud7" />
      {/* "@mention Giga in any channel" — lands right after we've shown how
       Giga works and what it connects to. */}
      <LivesInSlack data-id="element-9381" data-mp="1c2srpxuadss9" />
      <ComputerUse data-id="element-9382" data-mp="1guu2ffbt3bg6" />
      {/* "Under the hood" capability grid — the proof beat right after the
       machine behind Giga (ComputerUse). */}
      <CapabilityGrid data-id="element-9383" data-mp="jedjpv9koaqf" />
      <QuickCapture data-id="element-9384" data-mp="jf6fy2awnhub" />
      {/* Founder quote sits between the two product-demo moments as a human
       narrative pause. */}
      <NarrativeSection data-id="element-9385" data-mp="oc6pin6yr2q6" />
      <ProductDemo data-id="element-9386" data-mp="gdbobmecvsvq" />
      <ToolComparison data-id="element-9387" data-mp="gcs94dg3bile" />
      <WallOfLove data-id="element-9388" data-mp="gc0nnvg7j18u" />
      <PricingSection data-id="element-9389" data-mp="gbh3e83340rn" />
      <ClosingCTA data-id="element-9390" data-mp="bf0jjq2x48kd" />
    </>;
}